import PropTypes from "prop-types";
import React, { Component } from "react";
import { Checkbox } from "react-md";
import MDialog, { ACTION_APPLY, ACTION_CLOSE } from "components/Shared/MDialog.tsx";
import { DataTable, TableHeader, TableBody, TableRow, TableColumn } from "react-md/lib/DataTables";

class MDialogSelectList extends Component {
  constructor(props) {
    super(props);
  
    this.getActions = this.getActions.bind(this);
    this.rowClicked = this.rowClicked.bind(this);
    this.onApply = this.onApply.bind(this);

    let data = props.data.slice(0);

    if(props.showSelectAll) {
      data.unshift({
        checked: data.every(d => d.checked),
        label: props.selectAllLabel || "Select All",
        isSelectAll: true
      });
    }

    this.state = {
      data: data
    };
  }

  onApply() {
    this.props.onApply(this.state.data.filter(d => !d.isSelectAll));
  }
  
  getActions() {
    let actions = [];
    
    if(this.props.onApply) actions.push({ code: ACTION_APPLY, onClick: this.onApply });
    if(this.props.onClose) actions.push({ code: ACTION_CLOSE, onClick: this.props.onClose });
    if(this.props.onRefresh)
      actions.push({
        icon: "replay",
        helpText: this.props.refreshText || "Reset",
        onClick: this.props.onRefresh,
        order: 0
      });
    
    return actions;
  }

  rowClicked(row) {
    let newData = this.state.data.map(d => Object.assign({}, d));
    row = newData.find(d => d.label === row.label);

    row.checked = !row.checked;

    if(row.isSelectAll) {
      newData.forEach(d=> d.checked = row.checked);
    } else {
      if(this.props.showSelectAll) {
        newData.find(d => d.isSelectAll).checked = newData.every(d => d.checked || d.isSelectAll);
      }
    }

    this.setState({ data: newData });
  }

  render() {
    return (
      <MDialog
        id={this.props.id}
        title={this.props.title}
        actions={this.getActions()}
        focusOnMount={this.props.focusOnMount}
        width={this.props.width}
      >
        <DataTable plain className="card-dialog-list md-data-table__scroll-wrapper">
          { (this.props.valueTitle || this.props.labelTitle) &&
          <TableHeader>
            <TableRow>
              <TableColumn className="dialog-select-list-checked">{this.props.valueTitle || ""}</TableColumn>
              <TableColumn className="dialog-select-list-label">{this.props.labelTitle || ""}</TableColumn>
            </TableRow>
          </TableHeader>
          }
          <TableBody>
            {this.state.data.map(row => (
              <TableRow onClick={(e) => { e.preventDefault(); this.rowClicked(row); }} key={row.label}>
                <TableColumn style={{verticalAlign: "top", paddingTop: "5px"}} >
                  {/* need to provide name, id, label, and onChange so the checkbox list doesnt throw any warnings, onChange is used instead of changing checked to defaultChecked because then the box will not change its checked value when it is clicked*/}
                  <Checkbox name={row.label} id={row.label} label="" checked={row.checked} onChange={() => {}} />
                 </TableColumn>
                <TableColumn className="dialog-select-list-label" style={{verticalAlign: "center"}}>{row.label}</TableColumn>
              </TableRow>
            ))}
          </TableBody>
        </DataTable>
      </MDialog>
    );
  }
}

MDialogSelectList.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string.isRequired,
  valueTitle: PropTypes.string,
  labelTitle: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object), //[{ checked, label }]
  showSelectAll: PropTypes.bool,
  selectAllLabel: PropTypes.string,
  onApply: PropTypes.func, //called with data as a parameter
  onClose: PropTypes.func,
  onRefresh: PropTypes.func,
  refreshText: PropTypes.func,
  focusOnMount: PropTypes.bool,
  width: PropTypes.number,
};

export default MDialogSelectList;